var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"redeem"},[_c('redeem-flow',{attrs:{"offer":_vm.$route.params.offer}}),_c('illustration-mosaic')],1)}
var staticRenderFns = []

export { render, staticRenderFns }